// API DOC = https://swiperjs.com/swiper-api
import Swiper from 'swiper/bundle';
import {find, findMany, on} from '../helpers';

// Find all elements with the 'data-swipe-fade' attribute
const product = find('[data-swipe-product]');
const productThumbs = find('[data-swipe-thumbs]');

// Function to check and update Swiper based on breakpoints and criteria
const initSlider = () => {
    const thumbsNav = new Swiper(productThumbs, {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 0,
        resistanceRatio: 0.5,
        pagination: {
            el: '[data-swiper-pagination]',
            clickable: true,
            bulletActiveClass: '!bg-black/90',
            bulletClass: 'cursor-pointer rounded-full inline-block h-3.5 w-3.5 mx-1.5 bg-black/30 transition duration-300 ease-linear hover:bg-black/90',
            lockClass: 'hidden',
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            1024: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                speed: 800,
                pagination: false,
                navigation: {
                    nextEl: findMany('[data-swiper-next]', productThumbs),
                    prevEl: findMany('[data-swiper-prev]', productThumbs),
                    disabledClass: 'opacity-0',
                },
            },
        },
    });

    const primaryImage = new Swiper(product, {
        effect: 'fade',
        allowTouchMove: false,
        slidesPerView: 1,
        speed: 600,
        parallax: true,
        fadeEffect: {
            crossFade: true,
        },
        threshold: 10,
        spaceBetween: 0,
        thumbs: {
            swiper: thumbsNav.slides.length > 1 ? thumbsNav : null,
            multipleActiveThumbs: false,
        },
    });

    primaryImage.init();
    thumbsNav.init();

};

on('load', initSlider, window);
